import React from 'react';
import '../../../styles/Testimonial/testimonialConditions.scss';

/**
 * TermsAndConditions component that displays a checkbox with terms agreement text.
 * Uses improved class naming with the same styling approach.
 * @returns {JSX.Element} React component
 */
const TermsAndConditions = () => {
  // Extract the terms link and content as constants for better readability and maintainability
  const TERMS_URL = '/pages/share-your-flair-contest-terms-and-conditions';
  const TERMS_CONTENT = `
    And Acknowledge That The Entry In The Contest Constitutes Entrant's And Prize Winner's
    Consent (Without Limitation Including Geographical Limitation Or Compensation To Entrant)
    For Sponsor, And Any Third Party In Sponsor's Sole Discretion, To Use Entrant's Contest
    Entry, For Any Lawful Purpose, Including Without Limitation, The Entry And Associated
    Instagram Post, Entrant's And Nominee's Name, City And State Of Residence, Likeness,
    Photograph, Video, And Image For Advertising, Publicity And Promotional Purposes In Any
    Media, Online Or Offline, Without Further Permission, Consent, Payment Or Other
    Consideration, Except To The Extent Prohibited By Law.
  `
    .trim()
    .replace(/\s+/g, ' ');

  return (
    <div className="terms-checkbox-container">
      <div className="checkbox-wrapper">
        <input
          type="checkbox"
          id="terms-agreement"
          name="termsAgreement"
          className="checkbox-input"
          aria-describedby="terms-description"
        />
        <label htmlFor="terms-agreement" className="checkbox-label">
          <span className="terms-text">
            I Agree To The{' '}
            <a href={TERMS_URL} target="_blank" rel="noreferrer" className="terms-link">
              Terms & Conditions
            </a>{' '}
            {TERMS_CONTENT}
          </span>
        </label>
      </div>
    </div>
  );
};

export default TermsAndConditions;
export { TermsAndConditions as TestiTerms };
